// extracted by mini-css-extract-plugin
module.exports = {"container":"ActivePOIPopupOptions_container__Y_tpx"};